import getErrorResponse from "@/mixins/getResponseData";
import MiddlewareService from "@/MiddlewareService";
import constants from "@/store/admin/constants/admin";
import { BASE_URL } from "@/helpers/Constants";

export default {
  mixins: [getErrorResponse, MiddlewareService],
  methods: {
    /**
     * * Send request to API to get all building visitors
     *  @param {String} buildingId. Id of current building
     */
    async getBuildingVisitors(buildingId) {
      const data = await this.requestApi(`${BASE_URL}/visitors/building/${buildingId}`);
      if (data?.body?.success) {
        await this.$store.dispatch(constants.setBuildingVisitors, data.body.message);
      } else {
        this.$awn.alert(this.getErrorResponse(data));
      }
    },
  }
};
